/**
 * ObjectCard React component
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// react
import React from 'react';

// material UI
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Icon from "@material-ui/core/Icon/Icon";

// icons
import EditIcon from '@material-ui/icons/EditOutlined';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import UndoIcon from '@material-ui/icons/Undo';
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';
import FirstPageIcon from '@material-ui/icons/FirstPage';

// application
import TagList from "../base/TagList";
import MediaPanel from "../base/MediaPanel";
import FallbackImage from "../base/FallbackImage";


/**
 * ObjectCard visualizes the most important properties of a single object as a card
 *
 * @author Jens Gruschel, Maurizio Tidei
 */
export class ObjectCard extends React.Component {

    render() {

        const {classes} = this.props;

        if (this.props.type === 'mediaitem') {

            const mediaUrl = this.props.mediaurl;
            const thumbnailUrl = this.props.thumbnailurl;

            return (
                <Card className={classes.card}>
                    <CardActionArea onClick={event => this.props.onSelect()}>
                        <div className={classes.mediaPreviewUrl}>
                            <MediaPanel showControls={true} url={mediaUrl} thumbnail={thumbnailUrl} title={mediaUrl} playOnClick={false} otherFilesAsDownload={true} />
                        </div>
                        <CardContent className={classes.mediaCardContent}>
                            <Typography variant="subtitle1" className={classes.objectCardTitle} style={{color: "white", textAlign: "center"}}>
                                {this.props.title}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        {this.props.onEdit ? <Tooltip title="Bearbeiten"><IconButton onClick={() => this.props.onEdit()}><EditIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onDelete ? <Tooltip title="Löschen"><IconButton onClick={() => this.props.onDelete()}><DeleteIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onRemove ? <Tooltip title="Entfernen"><IconButton onClick={() => this.props.onRemove()}><RemoveCircleOutlineIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onUndelete ? <Tooltip title="Wiederherstellen"><IconButton onClick={() => this.props.onUndelete()}><UndoIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onMoveToFront ? <Tooltip title="An den Anfang setzen"><IconButton onClick={() => this.props.onMoveToFront()}><FirstPageIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                    </CardActions>
                </Card>
            );
        }
        else {

            const thumbnailUrl = this.props.thumbnailurl;

            return (
                <Card className={classes.card}>
                    <CardActionArea onClick={event => this.props.onSelect()}>
                        <FallbackImage urls={[thumbnailUrl]} title={this.props.titl} className={classes.objectImage} />
                        <CardContent className={classes.objectCardContent}>
                            <Typography variant="h5" className={classes.objectCardTitle} style={{textAlign: "center", fontSize: "1.3rem"}}>
                                {this.props.title ? this.props.title : "Unbenannt"}
                            </Typography>
                            <Typography gutterBottom component="p" className={classes.objectCardText}>
                                {this.props.description}
                            </Typography>
                            {this.props.mark && <div className={classes.objectCardMark}><Icon>{this.props.mark}</Icon></div>}
                        </CardContent>
                    </CardActionArea>
                    <div style={{textAlign: "left", margin: "-4px 10px", height: 30, overflow: "hidden"}}>
                        {this.props.tags && this.props.tags.length > 0 && <TagList tags={this.props.tags} onTagClick={this.props.onSearchTag}/>}
                    </div>
                    <CardActions className={classes.cardActions}>
                        {this.props.onEdit ? <Tooltip title="Bearbeiten"><IconButton onClick={() => this.props.onEdit()}><EditIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onDelete ? <Tooltip title="Löschen"><IconButton onClick={() => this.props.onDelete()}><DeleteIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onRemove ? <Tooltip title="Entfernen"><IconButton onClick={() => this.props.onRemove()}><RemoveCircleOutlineIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onUndelete ? <Tooltip title="Wiederherstellen"><IconButton onClick={() => this.props.onUndelete()}><UndoIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                        {this.props.onDuplicate ? <Tooltip title="Duplizieren"><IconButton onClick={() => this.props.onDuplicate()}><FileCopyIcon className={this.props.classes.actionButton}/></IconButton></Tooltip> : null}
                    </CardActions>
                </Card>
            );
        }
    }
}

const styles = theme => ({
    card: {
        width: 315,
        height: 335,
        margin: 3
    },
    cardActions: {
        padding: "0 2px"
    },
    objectCardContent: {
        paddingBottom: 0,
        paddingTop: 10
    },
    objectCardTitle: {
        overflow: 'hidden',
        whiteSpace: "nowrap",
        textOverflow: 'ellipsis',
        maxWidth: 275
    },
    objectCardText: {
        height: 22,
        overflow: 'hidden',
        whiteSpace: "nowrap",
        textOverflow: 'ellipsis',
        maxWidth: 275
    },
    objectCardMark: {
        position: "absolute",
        left: 8,
        top: 8,
        fontSize: 15,
        color: "#ffffff"
    },
    objectImage: {
        width: 315,
        height: 200,
        backgroundColor: "#c9e4ef",
        objectPosition: "50% 25%",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "cover"
    },
    objectPreviewMedia: {
        width: 315,
        height: 200,
        backgroundColor: "#c9e4ef",
        backgroundPosition: "50% 25%",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "cover"
    },
    mediaCardContent: {
        position: 'absolute',
        top: 220,
        left: 0,
        width: 315,
        height: 40,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1
    },
    mediaPreviewMedia: {
        width: 315,
        height: 280,
        backgroundColor: "#444444",
    },
    mediaPreviewUrl: {
        width: 315,
        height: 280,
        backgroundColor: "#444444",
        verticalAlign: "middle",
        display: "table-cell",
        position: "relative",
        overflow: "hidden"
    },
    mediaPreviewUrlText: {
        width: 315,
        fontSize: 15,
        color: "#ffffff",
        display: "inline-block",
    },
    actionButton: {
        color: "#4aa0d5"
    }
});

export default withStyles(styles)(ObjectCard);
